<template>
  <div class="event-log-widget">
    <div v-for="(ev, i) in displayEvents" :key="i" class="event-log-widget__row small mb-1 text-truncate">
      <span class="event-log-widget__time">{{ formatTime(ev.timestamp || ev.created_at) }}</span>
      <span class="badge badge-light ml-1">{{ ev.adapter || ev.type }}</span>
      {{ ev.action }}
    </div>
    <div v-if="!displayEvents.length" class="text-muted small">No events</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  props: { config: { type: Object, default: () => ({}) } },
  computed: {
    ...mapGetters('mission', ['events', 'liveEvents']),
    displayEvents() {
      const combined = [...this.liveEvents, ...this.events.map((e) => ({
        action: e.action,
        adapter: e.adapter,
        created_at: e.created_at,
      }))]
      return combined.slice(0, 30)
    },
  },
  watch: {
    'config.nodeId': {
      immediate: true,
      handler(id) { this.fetchEvents(id) },
    },
  },
  methods: {
    ...mapActions('mission', ['fetchEvents']),
    formatTime(t) {
      if (!t) return ''
      return moment(t).format('HH:mm:ss')
    },
  },
}
</script>

<style scoped>
.event-log-widget {
  color: var(--ws-text);
}
.event-log-widget__time {
  color: var(--ws-text-muted);
}
</style>
